"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  width: 512,
  height: 440,
  renderOption: {
    backgroundColor: 0Xf9f9f9
  }
};


//////////////////
// WEBPACK FOOTER
// ./app/Config.js
// module id = 90
// module chunks = 0